module.exports = __webpack_public_path__ + "assets/img/public.6973de8d.jpg";